import React from "react";
import { useTranslation } from "react-i18next";
import { structures } from "../data/structuresData";
import { CAMERE_KROSS } from "../data/krossbooking";

/**
 * Tendina per scegliere una camera precisa, raggruppata per struttura,
 * con la capienza massima accanto al nome. Vuoto = qualsiasi soluzione.
 */
export default function SelettoreCamera({ valore, onCambia, className = "" }) {
  const { t } = useTranslation();

  return (
    <label className={className}>
      <span className="block text-[10px] tracking-widest uppercase text-[#c9a962]">
        {t("ricerca.camera", "Camera")}
      </span>
      <select
        value={valore}
        onChange={(e) => onCambia(e.target.value)}
        className="w-full bg-[#14120f] text-[15px] font-semibold outline-none cursor-pointer truncate pr-1"
      >
        <option value="">
          {t("ricerca.qualsiasiCamera", "Qualsiasi soluzione")}
        </option>
        {structures.map((s) => (
          <optgroup key={s.id} label={s.fullName || s.name}>
            {s.rooms.map((r) => {
              const meta = CAMERE_KROSS[r.id];
              return (
                <option key={r.id} value={r.id}>
                  {t(r.nameKey)}
                  {meta ? ` · max ${meta.maxOspiti}` : ""}
                </option>
              );
            })}
          </optgroup>
        ))}
      </select>
    </label>
  );
}
